const processedAttr = 'data-ci-processed';

const bgContentAttr = 'data-ci-bg-container';

const canvasAttr = 'data-ci-canvas';

const loadedImageClassNames = ['ci-image-loaded', 'lazyloaded', 'ci-image'];

export {
  processedAttr,
  bgContentAttr,
  canvasAttr,
  loadedImageClassNames,
};
